// types
import { DefaultConfigProps, MenuOrientation, ThemeDirection, ThemeMode } from 'types/config';

// ==============================|| THEME CONSTANT  ||============================== //

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/';
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 260;

// Stripe publishable keys (safe for client-side — these are NOT the secret keys)
export const STRIPE_PUBLISHABLE_KEY_SANDBOX = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_SANDBOX || '';
export const STRIPE_PUBLISHABLE_KEY_LIVE = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_LIVE || '';

/** Local dev override for the bank-payment provider — production reads from Firestore config/portalFeatures.achProvider */
export const ACH_PROVIDER_OVERRIDE: 'stripe' | 'chase' | 'managed' | undefined =
  (import.meta.env.VITE_ACH_PROVIDER as 'stripe' | 'chase' | 'managed' | undefined) || undefined;

// ==============================|| THEME CONFIG  ||============================== //

const config: DefaultConfigProps = {
  fontFamily: `'Roboto', sans-serif`,
  i18n: 'en',
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  container: false,
  mode: ThemeMode.DARK,
  presetColor: 'default',
  themeDirection: ThemeDirection.LTR
};

export default config;
